import React, { useEffect, useRef, useState } from "react";
import FeatherIcon from "feather-icons-react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useModal from "../hooks/useModal";
import {CustomModal} from "./CustomModel/CustomModal";
import {toast} from "react-toastify";

const SelectInput = ({
                         data,
                         setData,
                         default_text,
                         label_text,
                         default_value,
                         input_name,
                         requiredField,
                         setInputValue,
                         create_form,
                         onBlockedClickText,
                         canWrite = true,
                         background = false,
                         search = false,
                         always_show_default_text=false,
                         disabled=false,
                         show_label = true
                     }) => {
    const [open, setOpen] = useState(false);
    const { modalIsOpen, setIsOpen, openModal } = useModal(false);
    const [id, setId] = useState(default_value);
    const [value, setValue] = useState(default_text);
    const [requiredStatus, setRequiredStatus] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const { t } = useTranslation();
    let menuRef = useRef();
    const CreateForm = create_form;

    useEffect(() => {
        let handler = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setOpen(false);
                setSearchQuery("");
            }
        };
        document.addEventListener("mousedown", handler);
        return () => {
            document.removeEventListener("mousedown", handler);
        };
    }, []);

    useEffect(() => {
        if (default_value) {
            const selectedItem = data.find(item => item.id === default_value);
            if (selectedItem) {
                setId(selectedItem.id);
                setValue(selectedItem.name);
            }
        } else {
            setId(null);
            setValue(default_text);
        }
    }, [default_value, data, default_text]);

    const onCheckedHandler = (id, value) => {
        setId(id);
        setValue(value);
        setOpen(false);
        setSearchQuery("");
        setRequiredStatus(true);
        if (setInputValue) setInputValue(id);
    };

    const handleClick = () => {
        if (disabled)
            return;
        if (!canWrite) {
            if (onBlockedClickText) toast.error(onBlockedClickText);
            return;
        }
        setOpen(!open);
    };

    const filteredData = (search && searchQuery)
        ? data.filter(item => item.name.toLowerCase().includes(searchQuery.toLowerCase()) || t(item.name).toLowerCase().includes(searchQuery.toLowerCase()))
        : data;

    return (
        <>
            <div className="relative input">
                {show_label && <Form.Label>{label_text} &nbsp;</Form.Label>}
                <div
                    className={`custom_select${open ? " is_active" : ""}${background ? " white" : ""}`}
                    onClick={handleClick}
                    ref={menuRef}
                >
                    <div className={`select_arrow${open ? " is_active" : ""}`}>
                        <FeatherIcon icon="chevron-down" />
                    </div>
                    {
                        always_show_default_text ? <p className={id ? "black" : ""}>{t(default_text)}</p>
                            :
                            <p className={value !== default_text ? "black" : ""}>{t(value)}</p>
                    }

                    <input type="text" name={input_name} defaultValue={id} style={{ display: "none" }} />

                    {! disabled && <div className={`options-menu ${open ? "block_active" : "block_inactive"}`}>
                        <div className="options-content-block">

                            {search && (
                                <div className="search-wrapper" onClick={e => e.stopPropagation()}>
                                    <div className="search-input-container">
                                        <FeatherIcon icon="search" />
                                        <input
                                            type="text"
                                            placeholder={t("Search...")}
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            className="search-input"
                                        />
                                    </div>
                                </div>
                            )}

                            {create_form &&
                                <div className="option create" style={{position: "relative"}} onClick={openModal}>
                                    <FeatherIcon icon="plus" size={8} style={{top: "11px", left: "5px"}}/>
                                    {t(`Create ${input_name}`)}
                                </div>
                            }

                            {filteredData.length > 0 ? (
                                filteredData.map(array => (
                                    <div
                                        key={array.id}
                                        className={`option ${array.id === id ? "active" : ""}`}
                                        onClick={() => onCheckedHandler(array.id, array.name)}
                                    >
                                        {t(array.name)}
                                    </div>
                                ))
                            ) : (
                                <div className="option empty-result" style={{cursor: "text"}}>
                                    {t("No results found")}
                                </div>
                            )}
                        </div>
                    </div>
                    }

                </div>
            </div>

            <div id="match-text" className={`up ${requiredField && !requiredStatus ? "active" : "hide"}`}>
                <Form.Text className={`text-muted alarm`}>
                    <FeatherIcon icon="alert-circle" /> {t("This field is required")}
                </Form.Text>
            </div>

            {create_form &&
                <CustomModal isOpen={modalIsOpen} onClose={() => setIsOpen(false)}>
                    <CreateForm
                        onClose={() => setIsOpen(false)}
                        onSuccess={(newItem) => {
                            setData(prev => [...prev, newItem]);
                            setInputValue(newItem.id);
                            setId(newItem.id);
                            setValue(newItem.name);
                            setSearchQuery("");
                            setIsOpen(false);
                        }}
                    />
                </CustomModal>
            }
        </>
    );
};

export default SelectInput;
